import React, {FunctionComponent, useContext, useState} from 'react';
import Pnotify from 'pnotify';

import Modal from '../../../ui/Modal/Modal';
import EmailContent from './EmailContent/EmailContent';
import {Context} from '../../../../store/context';
import {isValidEmail} from '../../../../utils/email';
import { analytics } from '../../../..';
import { AnalyticsEvents } from '../../../../store/AnalyticsStore';

interface IEmailModal {
    onClose: () => void;
}

const EmailModal: FunctionComponent<IEmailModal> = ({onClose}) => {
    const {queryParamsStore, emailTemplatesStore} = useContext(Context);
    const {sendEmail} = emailTemplatesStore;
    const {queryParams} = queryParamsStore

    const [emailInput, setEmailInput] = useState<string>('');
    const [emailContent, setEmailContent] = useState<string>('');

    const onSendClick = async () => {
        if(!queryParams) return;

        analytics.logEvent(AnalyticsEvents.SubmitShareEmail)

        const isEmailValid = isValidEmail(emailInput);
        if(!isEmailValid) {
            return new Pnotify({
                title: 'Incorrect email',
                text: 'Please, enter valid email',
                addclass: 'bg-danger'
            })
        }
        const result = {
            email:
                {
                    buildingId: queryParams.buildingId,
                    content: emailContent,
                    address: emailInput
                }
        };

        await sendEmail(result);
        onClose();
    };

    const buttons = (
        <button
            type="button"
            className="btn btn-success"
            onClick={onSendClick}
        >
            Send
        </button>
    );


   return (
       <Modal
           header = "Please, enter your email address"
           onClose = {onClose}
           buttons = {buttons}
       >
           <EmailContent
               emailInput = {emailInput}
               setEmailInput = {setEmailInput}
               setEmailContent = {setEmailContent}
           />
       </Modal>
   )
};

export default EmailModal;
